/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Print_Hub_LabelInputs */

const en_print_hub_label = /** @type {(inputs: Print_Hub_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Print Hub Label`)
};

const es_print_hub_label = /** @type {(inputs: Print_Hub_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Imprimir Etiqueta Hub`)
};

const fr_print_hub_label = /** @type {(inputs: Print_Hub_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Imprimer l'étiquette Hub`)
};

const de_print_hub_label = /** @type {(inputs: Print_Hub_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hub-Etikett drucken`)
};

const id_print_hub_label = /** @type {(inputs: Print_Hub_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cetak Label Hub`)
};

/** @type {(inputs: Print_Hub_LabelInputs) => LocalizedString} */
const ja_print_hub_label = en_print_hub_label;

/** @type {(inputs: Print_Hub_LabelInputs) => LocalizedString} */
const zh_print_hub_label = en_print_hub_label;

/** @type {(inputs: Print_Hub_LabelInputs) => LocalizedString} */
const ar_print_hub_label = en_print_hub_label;

/** @type {(inputs: Print_Hub_LabelInputs) => LocalizedString} */
const it_print_hub_label = en_print_hub_label;

/** @type {(inputs: Print_Hub_LabelInputs) => LocalizedString} */
const ru_print_hub_label = en_print_hub_label;

/** @type {(inputs: Print_Hub_LabelInputs) => LocalizedString} */
const pt_print_hub_label = en_print_hub_label;

/** @type {(inputs: Print_Hub_LabelInputs) => LocalizedString} */
const ko_print_hub_label = en_print_hub_label;

/**
* | output |
* | --- |
* | "Print Hub Label" |
*
* @param {Print_Hub_LabelInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const print_hub_label = /** @type {((inputs?: Print_Hub_LabelInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Print_Hub_LabelInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_print_hub_label(inputs)
	if (locale === "es") return es_print_hub_label(inputs)
	if (locale === "fr") return fr_print_hub_label(inputs)
	if (locale === "de") return de_print_hub_label(inputs)
	if (locale === "ja") return ja_print_hub_label(inputs)
	if (locale === "zh") return zh_print_hub_label(inputs)
	if (locale === "ar") return ar_print_hub_label(inputs)
	if (locale === "id") return id_print_hub_label(inputs)
	if (locale === "it") return it_print_hub_label(inputs)
	if (locale === "ru") return ru_print_hub_label(inputs)
	if (locale === "pt") return pt_print_hub_label(inputs)
	return ko_print_hub_label(inputs)
});